import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { getQueueStatisticsFavorites } from 'flow/utils/browser-utils';
import { getServiceLevelsForQueue } from 'flow/utils/servicelevel-utils';
import { selectQueueStatsSummary } from 'flow/selectors/queue-selectors';
import { fetchQueueStatSummary } from 'flow/actions/pbx-actions';
import { QueueKey } from 'flow/types/EntityKeys';
import AgentStatisticsPreview from 'flow/components/pbx/AgentStatisticsPreview';

const intervals = ['today', 'week', 'month'];
const THIRTY_SECONDS_MS = 30 * 1000;

interface Props {
    queueKey: QueueKey;
}

const QueueAgentStatisticsPreview = ({ queueKey }: Props) => {
    const dispatch = useAppDispatch();
    const queueStatsSummary = useAppSelector((state) =>
        selectQueueStatsSummary(state, queueKey),
    );

    const [current, setCurrent] = useState(0);

    const handleQueueStatisticsIntervalChange = useCallback(
        (intervalResolution: string) =>
            dispatch(
                fetchQueueStatSummary(
                    queueKey,
                    getServiceLevelsForQueue(queueKey),
                    intervalResolution,
                ),
            ),
        [dispatch, queueKey],
    );

    useEffect(() => {
        dispatch(
            fetchQueueStatSummary(
                queueKey,
                getServiceLevelsForQueue(queueKey),
                'today',
            ),
        );
    }, [dispatch, queueKey]);

    useEffect(() => {
        const statSummaryRefresh = setInterval(() => {
            handleQueueStatisticsIntervalChange(intervals[current]);
        }, THIRTY_SECONDS_MS);

        return () => {
            clearInterval(statSummaryRefresh);
        };
    }, [current, handleQueueStatisticsIntervalChange]);

    return (
        <AgentStatisticsPreview
            statSummary={queueStatsSummary}
            getStatisticsFavorites={getQueueStatisticsFavorites}
            handleStatisticsIntervalChange={handleQueueStatisticsIntervalChange}
            current={current}
            setCurrent={setCurrent}
        />
    );
};

export default QueueAgentStatisticsPreview;
